import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { OfferSelector } from '../offers/OfferSelector';
import { OfferId } from '../offers/offerData';
import { PurchaseButton } from '../offers/PurchaseButton';
import { Countdown } from '../ui/Countdown';
import { Section } from '../ui/Section';
type Props = {
  selectedOffer: OfferId;
  onSelectOffer: (offer: OfferId) => void;
};
export function Pricing({
  selectedOffer,
  onSelectOffer
}: Props) {
  return <Section id="planes" className="bg-cream" data-id="element-201" data-mp="3pi6hz211wt3q">
      <div className="mx-auto max-w-3xl rounded-2xl bg-white p-4 text-center shadow-sm ring-1 ring-rosegold/15 sm:rounded-3xl sm:p-8" data-id="element-202" data-mp="3uikt4sxy8j5z">
        <div className="flex items-center justify-center gap-1.5 text-xs font-semibold text-rose sm:gap-2 sm:text-sm" data-id="element-203" data-mp="3b8asalbxzoh">
          <FlameIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" data-id="element-204" data-mp="2064ep4v01yq1" />
          Oferta en vivo · +$10.000 después
        </div>
        <div className="mt-3 sm:mt-5" data-id="element-205" data-mp="255qrjd6x1cyb"><Countdown variant="light" data-id="element-206" data-mp="1bagm00bhrfy8" /></div>
        <div className="mx-auto mt-3 max-w-sm sm:mt-6" data-id="element-207" data-mp="1bbi8r21vdqvs">
          <div className="flex justify-between text-[10px] font-medium text-plum sm:text-xs" data-id="element-208" data-mp="16ka1abk3ofl9"><span data-id="element-209" data-mp="16i6yeqxumrz4">Cupos restantes</span><span className="text-rose" data-id="element-210" data-mp="11kf8g2grlfxk">68% tomados</span></div>
          <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-blush sm:mt-2 sm:h-2.5" data-id="element-211" data-mp="11iuh0lpqyd3x"><motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9
          }} className="h-full rounded-full bg-rose" data-id="element-212" data-mp="xkwmd3d7iyt5" /></div>
        </div>
      </div>

      <div className="mx-auto mt-7 max-w-xl text-center sm:mt-10" data-id="element-213" data-mp="1pbausk2gbixf">
        <h2 className="font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-214" data-mp="1l7v3m395ias4">Elegí tu Kit de Colorimetría PRO</h2>
        <p className="mt-2 text-sm text-plum" data-id="element-215" data-mp="1g9jphgbtpe43">Las dos opciones incluyen los 6 bonos.</p>
      </div>

      <div className="mx-auto mt-7 max-w-xl sm:mt-10" data-id="element-216" data-mp="9v2aop4mjgah">
        <OfferSelector selectedOffer={selectedOffer} onSelect={onSelectOffer} data-id="element-217" data-mp="4uem0a3vbbjf" />
        <PurchaseButton selectedOffer={selectedOffer} className="mt-4 bg-rose text-white shadow-rose/30 hover:bg-rose/90 sm:mt-5" data-id="element-218" data-mp="6c3aehf7io4i" />
      </div>

      <div className="mx-auto mt-5 flex max-w-2xl flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] text-plum sm:mt-8 sm:gap-x-6 sm:gap-y-2 sm:text-xs" data-id="element-219" data-mp="baej2otrmsl5">
        <span className="flex items-center gap-1" data-id="element-220" data-mp="1bz1bcgmovob"><LockIcon className="h-3 w-3 text-rosegold sm:h-4 sm:w-4" data-id="element-221" data-mp="1axgwhdq2wtx" />Pago seguro</span>
        <span className="flex items-center gap-1" data-id="element-222" data-mp="3jp5b12e8ydpg"><ZapIcon className="h-3 w-3 text-rosegold sm:h-4 sm:w-4" data-id="element-223" data-mp="3ohg9s1x93tgf" />Acceso en 5 min</span>
        <span className="flex items-center gap-1" data-id="element-224" data-mp="3oj9jxr72ovt6"><ShieldCheckIcon className="h-3 w-3 text-rosegold sm:h-4 sm:w-4" data-id="element-225" data-mp="39tbr2xy77hxn" />Garantía 7 días</span>
        <span data-id="element-226" data-mp="3eqvfursivd3u">💳 Mercado Pago</span>
      </div>
    </Section>;
}